import { createComponent } from '../utils';
import { useHStack } from './useHStack';
export default createComponent({
  useHook: useHStack,
  name: 'HStack'
});